var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUruguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8516C24.8366 32.8516 32 25.6881 32 16.8516C32 8.01501 24.8366 0.851562 16 0.851562C7.16344 0.851562 0 8.01501 0 16.8516C0 25.6881 7.16344 32.8516 16 32.8516Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6778H31.4488C31.0476 11.1895 30.4379 9.78691 29.6516 8.50391H16V12.6778Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04045 29.3732H25.96C27.4202 28.2102 28.6724 26.7975 29.6518 25.1992H2.34863C3.32807 26.7975 4.58032 28.2102 6.04045 29.3732Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.851562V4.32981H25.9598C23.2267 2.15306 19.7656 0.851562 16 0.851562Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6778H31.4488C31.0476 11.1895 30.4379 9.78691 29.6516 8.50391H16V12.6778Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8516C0 18.2958 0.1925 19.6946 0.551188 21.0255H31.4489C31.8075 19.6946 32 18.2958 32 16.8516H0Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 10.2151L11.9589 11.1343L12.9995 13.0268L10.8776 12.621L10.6088 14.7644L9.13088 13.1879L7.65288 14.7644L7.38407 12.621L5.26219 13.0267L6.30269 11.1343L4.34869 10.2151L6.30276 9.29608L5.26219 7.40358L7.38401 7.80945L7.65294 5.66602L9.13088 7.24252L10.6088 5.66602L10.8776 7.80945L12.9996 7.40358L11.959 9.29614L13.9131 10.2151Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUruguay);
export default __webpack_public_path__ + "static/media/flag_uruguay.6e2c1a0bb6bae1044430cbec8d58aaad.svg";
export { ForwardRef as ReactComponent };